import { AppAction, AppState } from './contextTypes';

const AppReducer = (state: AppState, action: { type: AppAction; payload: any }) => {
  switch (action.type) {
    case AppAction.SET_PARTNER_AND_SETTINGS:
      return {
        ...state,
        partner: action.payload.partner,
        settings: action.payload.settings
      };
    case AppAction.SET_TRACKING_DETAILS:
      return {
        ...state,
        trackingDetails: action.payload,
        isCustomerInputsOpen: !action.payload.task.consumerUpdatedInfoAt
      };
    case AppAction.SET_CUSTOMER_INPUTS_OPEN:
      return {
        ...state,
        isCustomerInputsOpen: !state.isCustomerInputsOpen
      };
    case AppAction.SET_BANKID_ORDER_REF:
      return {
        ...state,
        bankId: {
          orderRef: action.payload
        }
      };
    case AppAction.SET_POLLING_STATUS:
      return {
        ...state,
        isPolling: !state.isPolling
      };
    default:
      return state;
  }
};

export default AppReducer;
